<template>
    <div class="home">
       
        <div class="mecanic" v-for="mecanic in Mecanici" :key="'mecanic_' + mecanic.Id">
            <p>{{mecanic.Nume}}</p>
            <div v-for="deviz in mecanic.Programari" :key="mecanic.Id + '_deviz_' + deviz.Id" 
            :class="deviz.Status === 'In asteptare' ? 'deviz-waiting' :
                deviz.Status == 'Draft' ? 'deviz-draft' : deviz.Status == 'Aprobat' ? 'deviz-aprobat' : 'deviz-finalizat'">
             <p>{{deviz.Numar.toUpperCase()}}</p>
             {{deviz.Status == 'Draft' ? 'In lucru' : deviz.Status}}
             <span>{{new Date(deviz.DataRezervarii) | OraFaraSec}}</span>
            </div>
        </div>
        <!-- {{this.Mecanici }} -->
        <hr/>

    </div>
</template>

<script>
import LocalSettings from '../backend/LocalSettings';

    export default {
        name: "Masini_dasboard",
        data() {
            return {
                // EMecanici: '',
                base_url:'',
                Mecanici: [ ],
                refresh_interval: null,
            }
        },
        methods: {
            async get_info(){
                let args = {
                    // Id: previous_month,
                    // idCentruProductie: this.serviciu_selectat.centru,
                };
                const url = this.base_url + '/dashboard_mecanici'
                let response = await this.$http.post(url, args);
                // console.log(response)
                this.Mecanici = response.body.mecanici;
            },

        },


        created() {
            this.get_info();
            this.refresh_interval = setInterval(() => {
                this.get_info();
            }, 30000)
        },
        mounted(){
            this.base_url = LocalSettings.BASE_URL + "/test_api";
        },
        beforeDestroy() {
            clearInterval(this.refresh_interval);
        }
    }
</script>

<style lang="less" scoped>
 .home {
    background-color: rgb(43, 42, 42);
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1%;
    flex-wrap: nowrap;
    user-select: none;

    .mecanic {
        width: 49%;
        height: 100vh;
        max-height: 100vh;
        // margin-top: 1%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-direction: column;
        padding: 20px;
        // border: 1px solid rgba(0, 0, 0, 0.436);
        // border-radius: 10px;
        // box-shadow: 0.5px 0.5px 5px rgba(0, 0, 0, 0.495);
        p {
            font-size: 32px;
            font-weight: 600;
            color: white;

        }

        .deviz-aprobat {
            margin: 10px 0;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            box-shadow: 0.5px 0.5px 5px rgba(0, 0, 0, 0.495);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-color: rgb(172, 248, 172);
            p {
                color: black;
            }
            span {
                font-size: 26px;
            }
        }

        .deviz-draft {
            margin: 10px 0;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            box-shadow: 0.5px 0.5px 5px rgba(0, 0, 0, 0.495);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            background-color: rgb(239, 239, 166);
            p {
                color: black;
            }
            span {
                font-size: 26px;
            }
        }

        .deviz-finalizat {
            margin: 10px 0;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            box-shadow: 0.5px 0.5px 5px rgba(0, 0, 0, 0.495);
            background-color: rgb(59, 153, 59);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            p {
                color: black;
            }
            span {
                font-size: 26px;
            }
        }

        .deviz-waiting {
            margin: 10px 0;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            box-shadow: 0.5px 0.5px 5px rgba(0, 0, 0, 0.495);
            background-color: rgb(147, 147, 147);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            p {
                color: black;
            }
            span {
                font-size: 26px;
            }
        }
    }
 }
</style>